import { Tab } from "@mui/base/Tab";
import { TabPanel } from "@mui/base/TabPanel";
import { Tabs } from "@mui/base/Tabs";
import { TabsList } from "@mui/base/TabsList";

import labels from "~/helpers/labels";

import styles from "./Subscription.module.scss";

const payAsYouGoHeader = [
  "Feature",
  "Free Limits",
  "Price Per Unit",
  "Total Price",
];
const payAsYouGoHeaderNoFreeLimits = ["Feature", "QTY", "Price Per Unit"];

type PayAsYouGoProps = {
  dataFreeLimits: {
    Feature: string;
    "Free Limits": JSX.Element;
    "Price Per Unit": string;
    "Total Price": string;
  }[];
  dataNoFreeLimits: {
    Feature: string;
    QTY: JSX.Element;
    "Price Per Unit": string;
  }[];
};

const PayAsYouGoTable = <Row extends Partial<Record<string, React.ReactNode>>>({
  headers,
  rows,
}: {
  headers: string[];
  rows: Row[];
}) => (
  // @ts-expect-error TS2339 non-existing className
  <table className={styles.table}>
    <thead>
      <tr>
        {headers.map((header) => (
          <th key={header}>{header}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows?.map((row, index) => (
        <tr key={index}>
          {headers.map((header) => (
            <td key={header}>{row?.[header as keyof typeof row]}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

const PayAsYouGo = ({ dataFreeLimits, dataNoFreeLimits }: PayAsYouGoProps) => {
  const hasFreeLimits = dataFreeLimits?.length > 0;
  const hasNoFreeLimits = dataNoFreeLimits?.length > 0;

  // The parent hides the whole section in this case; keep the guard so the
  // component never renders an empty tab bar on its own.
  if (!hasFreeLimits && !hasNoFreeLimits) {
    return null;
  }

  // A single populated group needs no tab bar
  if (!hasFreeLimits || !hasNoFreeLimits) {
    return hasFreeLimits ? (
      <PayAsYouGoTable headers={payAsYouGoHeader} rows={dataFreeLimits} />
    ) : (
      <PayAsYouGoTable
        headers={payAsYouGoHeaderNoFreeLimits}
        rows={dataNoFreeLimits}
      />
    );
  }

  return (
    <Tabs defaultValue={labels.FREE_LIMIT_AVAILABLE}>
      <TabsList className={styles.tabsList}>
        <Tab className={styles.tabButton} value={labels.FREE_LIMIT_AVAILABLE}>
          {labels.FREE_LIMIT_AVAILABLE}
        </Tab>
        <Tab className={styles.tabButton} value={labels.NO_FREE_LIMIT}>
          {labels.NO_FREE_LIMIT}
        </Tab>
      </TabsList>
      <TabPanel value={labels.FREE_LIMIT_AVAILABLE}>
        <PayAsYouGoTable headers={payAsYouGoHeader} rows={dataFreeLimits} />
      </TabPanel>
      <TabPanel value={labels.NO_FREE_LIMIT}>
        <PayAsYouGoTable
          headers={payAsYouGoHeaderNoFreeLimits}
          rows={dataNoFreeLimits}
        />
      </TabPanel>
    </Tabs>
  );
};
export default PayAsYouGo;
